export default __webpack_public_path__ + "static/media/fatimaNcake_w320.efa1c8b3.jpeg";